var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as R from 'ramda';
/** 创建动作协议 */
export var createActionSchema = function (instance) {
    var action = instance.action, rest = __rest(instance, ["action"]);
    var result = __assign(__assign({}, R.clone(rest)), { id: action.id });
    return result;
};
/** 创建热区协议 */
export var createHotAreaSchema = function (instance) {
    var actions = instance.actions, rest = __rest(instance, ["actions"]);
    var result = __assign(__assign({}, R.clone(rest)), { actions: actions.map(createActionSchema) });
    return result;
};
/** 创建组件协议 */
export var createComponentSchema = function (instance) {
    var children = instance.children, parent = instance.parent, component = instance.component, actions = instance.actions, hotAreas = instance.hotAreas, data = instance.data, rest = __rest(instance, ["children", "parent", "component", "actions", "hotAreas", "data"]);
    var result = __assign(__assign({}, R.clone(rest)), { id: component.id, data: R.clone(data), actions: actions.map(createActionSchema) });
    if (component.__implementHotArea && hotAreas) {
        result.data = __assign(__assign({}, data), { hotAreas: hotAreas.map(createHotAreaSchema), __implementHotArea: true });
    }
    if (children) {
        result.children = children.map(function (child) { return createComponentSchema(child); });
    }
    return result;
};
/** 创建插件协议 */
export var createPluginSchema = function (instance) {
    var plugin = instance.plugin, rest = __rest(instance, ["plugin"]);
    var result = R.clone(rest);
    return result;
};
/** 获取页面协议 */
export var getSchema = function (pageInstance) {
    return {
        components: pageInstance.componentInstances.map(function (instance) { return createComponentSchema(instance); }),
        plugins: pageInstance.pluginInstances.map(function (instance) { return createPluginSchema(instance); }),
        version: R.clone(pageInstance.version),
    };
};
//# sourceMappingURL=SchemaGenerator.js.map